import React from "react";

// image import
import LogoLeft from '../img/oval_logo.png';
import LogoRight from '../img/oval_tech.png';



class Header extends React.Component {
  render() {
    return (
      <nav class="navbar navbar-expand-md fixed-top">
        <div class = 'container-fluid'>
          <a class="navbar-brand" href="#"><img src={LogoLeft} alt = "Oval" width = '30px'/></a>
          <a href="#" class="navbar-brand float-right"><img src={LogoRight} alt = "Oval Tech" width = '100px'/></a>
        </div>
      </nav>
    )
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js